import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

function Tarifas() {
  const isMobile = useIsMobile();

  return (
    <main style={{ padding: '3rem 1.5rem', maxWidth: isMobile ? '860px' : '1180px', margin: '0 auto' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: 'clamp(1.5rem, 5vw, 2rem) clamp(1.25rem, 5vw, 2.5rem)',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <h1 style={{ color: theme.colors.primary, fontSize: '1.6rem', marginBottom: '0.5rem', textAlign: 'center' }}>
          Tarifas
        </h1>
        <div style={{
          width: '40px',
          height: '3px',
          backgroundColor: theme.colors.primary,
          margin: '0 auto 1.8rem',
          borderRadius: '2px',
        }} />

        <p style={{ color: theme.colors.primary, fontSize: '1.05rem', fontWeight: '700', textAlign: 'center', margin: '0 0 0.3rem' }}>
          💳 Paquetes de recarga
        </p>
        <p style={{ color: theme.colors.textMuted, fontSize: '0.8rem', textAlign: 'center', margin: '0 0 0.3rem' }}>
          Recarga más saldo pagando menos. El bono se acredita al instante.
        </p>
        <p style={{ color: theme.colors.textMuted, fontSize: '0.72rem', textAlign: 'center', margin: '0 0 1.2rem', fontStyle: 'italic' }}>
          ⚠️ Estos paquetes aplican únicamente al plan de Página Web ($500/día).
        </p>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(auto-fit, minmax(220px, 1fr))' : 'repeat(2, minmax(0, 1fr))',
          gap: '1.2rem',
          maxWidth: isMobile ? 'none' : '720px',
          margin: isMobile ? '0 0 2rem' : '0 auto 2rem',
        }}>
          <div style={{
            backgroundColor: theme.colors.background,
            borderRadius: '10px',
            border: `1px solid ${theme.colors.primary}`,
            padding: '1.5rem',
            textAlign: 'center',
          }}>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.82rem', marginBottom: '0.5rem' }}>📅 Paquete 15 días</p>
            <p style={{ color: theme.colors.primary, fontSize: '1.6rem', fontWeight: '700', margin: '0 0 0.3rem' }}>
              $6.000 <span style={{ fontSize: '0.85rem', fontWeight: '400' }}>COP</span>
            </p>
            <p style={{ color: theme.colors.text, fontSize: '0.82rem', margin: 0 }}>Recibes <strong>$7.500</strong> de saldo</p>
            <p style={{ color: theme.colors.text, fontSize: '0.7rem', margin: '0.4rem 0 0' }}>Ahorras $1.500 · te regalamos un bono por la diferencia.</p>
          </div>
          <div style={{
            backgroundColor: theme.colors.background,
            borderRadius: '10px',
            border: `1px solid ${theme.colors.primary}`,
            padding: '1.5rem',
            textAlign: 'center',
          }}>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.82rem', marginBottom: '0.5rem' }}>📅 Paquete 30 días</p>
            <p style={{ color: theme.colors.primary, fontSize: '1.6rem', fontWeight: '700', margin: '0 0 0.3rem' }}>
              $10.000 <span style={{ fontSize: '0.85rem', fontWeight: '400' }}>COP</span>
            </p>
            <p style={{ color: theme.colors.text, fontSize: '0.82rem', margin: 0 }}>Recibes <strong>$15.000</strong> de saldo</p>
            <p style={{ color: theme.colors.text, fontSize: '0.7rem', margin: '0.4rem 0 0' }}>Ahorras $5.000 · te regalamos un bono por la diferencia.</p>
          </div>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '1.2rem',
          width: '100%',
        }}>
          <div style={{
            backgroundColor: theme.colors.background,
            borderRadius: '10px',
            border: `1px solid ${theme.colors.border}`,
            padding: '1.5rem',
            textAlign: 'center',
            width: '100%',
            maxWidth: '350px',
          }}>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.82rem', marginBottom: '0.5rem' }}>🌐 Tu Página Web Profesional</p>
            <p style={{ color: theme.colors.primary, fontSize: '1.6rem', fontWeight: '700', margin: '0 0 0.3rem' }}>
              $500 <span style={{ fontSize: '0.85rem', fontWeight: '400' }}>COP/día</span>
            </p>
            <p style={{ color: theme.colors.text, fontSize: '0.82rem', margin: 0 }}>Tu negocio en internet, sin complicaciones</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸Tu propia página web lista para mostrar tu negocio al mundo, accesible desde cualquier celular o computador, las 24 horas del día.</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸🛍️ Carrusel de tienda: exhibe tus productos con fotos, precios y descripciones de forma atractiva para que tus clientes vean todo tu catálogo de un vistazo.</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸🧰 Carrusel de servicios: presenta los servicios que ofreces de manera clara y profesional para captar más clientes.</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸🎫 Sistema de tickets: tus clientes pueden crear tickets desde la página para hacer pedidos, solicitudes o dudas, y tú los gestionas de forma ordenada.</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸📰 Publicación de noticias: mantén informados a tus clientes publicando novedades, promociones y anuncios directamente en tu página.</p>
            <p style={{ color: theme.colors.text, fontSize: '0.60rem', margin: 5, textAlign: 'left' }}>🔸💼 Ideal para emprendedores que quieren empezar su presencia digital con una inversión mínima y dar el primer gran paso de su negocio.</p>
          </div>

        </div>
        <p style={{ color: theme.colors.textMuted, fontSize: '0.8rem', textAlign: 'center', marginTop: '1.2rem', margin: '1.2rem 0 0' }}>
          El cobro se realiza diariamente. El acceso se suspende automáticamente cuando el saldo disponible sea insuficiente.
        </p>
      </div>
    </main>
  );
}

export default Tarifas;
